import { createSlice } from '@reduxjs/toolkit';

import { getObjectiveDetailsRoute, getTaskDetailsRoute } from 'constants/helper';
import { OKR_TYPES } from 'constants/ProjectConstants';

const initialState = {
  onUpdate: null,
  onDelete: null,
};

export const okrDrawerControlSlice = createSlice({
  name: 'okrPanelKebabMenuActionsSlice',
  initialState,
  reducers: {
    openOKRPanel: (state, action) => {
      state.onDelete = action.payload.onDelete;
      state.onUpdate = action.payload.onUpdate;
    },
    closeOKRPanel: () => initialState,
  },
});

const { openOKRPanel, closeOKRPanel: hideOKRDetails } = okrDrawerControlSlice.actions;

const showOKRDetails = (payload) => (dispatch) => {
  /* read defaults based on access control from store and pass */

  const { id, type, onDelete, onUpdate, scrollToId = '', history } = payload;

  if (type === OKR_TYPES.OBJECTIVE) {
    history.replace(
      getObjectiveDetailsRoute({
        location: history.location,
        objectivePId: id,
        scrollToId,
      })
    );
  } else {
    history.replace(
      getTaskDetailsRoute({
        location: history.location,
        ids: [id],
        type,
        scrollToId,
      })
    );
  }

  dispatch(
    openOKRPanel({
      onDelete,
      onUpdate,
    })
  );
};

export { hideOKRDetails, showOKRDetails };
export default okrDrawerControlSlice.reducer;
